/**
 * Homepage search-first visual rhythm (section vertical padding in px).
 * Matches Homepage UI/UX Refresh v2 spacing pattern.
 */

export const HOMEPAGE_HERO_BG = '#F8FAFC';

export const HOMEPAGE_SECTION_PY = {
  trust: { xs: 5, md: 10 }, // ~80px desktop
  host: { xs: 6, md: 12.5 }, // ~100px
  upcoming: { xs: 7, md: 15 }, // ~120px
  browse: { xs: 5, md: 10 }, // ~80px
  benefits: { xs: 7, md: 15 }, // ~120px
  articles: { xs: 6, md: 12.5 }, // ~100px
} as const;

export const HOMEPAGE_CARD_RADIUS = 3;
export const HOMEPAGE_CARD_SHADOW = '0 4px 20px rgba(15, 23, 42, 0.06)';
export const HOMEPAGE_CARD_SHADOW_HOVER = '0 10px 28px rgba(15, 23, 42, 0.1)';
